"use client"
import React, {useEffect, useState} from "react";
import {
    GAME_KEY,
    HOME_KEY,
    LOGO_ICON,
    LOGO_TEXT_ADDRESS,
    SEARCH_ICON_ADDRESS, SEARCH_KEY,
    STORE_KEY,
    TOOLS_KEY,
    VIDEO_KEY
} from "@/core/CONSTANTS";
import {useTranslations} from "use-intl";
import {Alert, Container, IconButton, Snackbar, SwipeableDrawer, Tab, Tabs} from "@mui/material";
import {usePathname, useRouter} from "next/navigation";
import Image from "next/image";
import MenuIcon from '@mui/icons-material/Menu';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import {saveLastTab, saveLoginParams} from "@/core/services/localStorage.service";
import {ENGLISH_APP, LOGIN_STATE_KEY, SH_TITLE, THEME_STATE_KEY} from "@/core/services/CONSTANTS";
import {Column} from "@/core/general/column.component";
import {Row} from "@/core/general/row.component";
import {toPersianNumber} from "@/core/utils/number.utils";
import {BlueButton} from "@/core/general/button/blue.button";
import {
    CAFE_DOWNLOAD_IMAGE,
    CAFE_TOOLBOX_URL,
    DIRECT_CAFE_TOOLBOX_URL,
    DIRECT_DOWNLOAD_EN_IMAGE,
    DIRECT_DOWNLOAD_IMAGE,
    MYKET_DOWNLOAD_IMAGE,
    MYKET_TOOLBOX_URL,
    PLAY_DOWNLOAD_IMAGE,
    PLAY_TOOLBOX_URL
} from "@/core/tools/profile/CONSTANTS";
import {Vazirmatn} from "next/font/google";
import IosShareIcon from '@mui/icons-material/IosShare';
import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined';
import Profile from "@/core/tools/profile/profile";
import {AppDispatch, RootState} from "@/core/redux/store";
import {TypedUseSelectorHook, useDispatch, useSelector} from "react-redux";
import useLocalStorage from "@/core/utils/localStorage";
import {WorldModel} from "@/core/tools/world_wiki/worldCountry.model";
import LogoutUser from "@/core/tools/profile/login/logoutUser.component";
import LoginEnterNumber from "@/core/tools/profile/login/loginEnterNumber.component";
import LayoutDrawer from "@/core/general/layoutDrawer.component";

const vazirmatn = Vazirmatn({subsets: ['arabic'], variable: '--vazirmatn'});
import * as rdd from 'react-device-detect';
import {LOGIN_STATE, LOGOUT_STATE} from "@/core/reducer/CONSTANTS";
import RTLContainer from "@/core/general/rtlContainer.component";
import WorldCountryList from "@/core/tools/world_wiki/WorldCountryList";
import {loginState} from "@/core/reducer/loginReducer";
import {SEARCH_SHORTCUT} from "@/core/navigation/CONSTANTS";
import {GoogleReCaptchaProvider} from "react-google-recaptcha-v3";


export default function MenuTabComponent() {

    const pathname = usePathname()
    const [tabValue, setTabValue] = useState<string>(pathname?.replace("/", "").trim() == "" ? HOME_KEY : (checkMainTabs() ? pathname?.replace("/", "").trim() : ""));
    const t = useTranslations();
    const router = useRouter();
    const [hasToolbar, setHasToolbar] = useState(false);
    const [hasMargin, setHasMargin] = useState(true);
    const [mainTab, setMainTab] = useState(false);
    const [searchPath, setSearchPath] = useState(false);
    // const searchParams = useSearchParams()
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [installPopUpOpen, setInstallPopUpOpen] = useState(false);
    const [isIosPopUp, setIosPopUp] = useState(false);
    const [isLogin, setLogin] = useLocalStorage<boolean>(LOGIN_STATE_KEY, false);
    const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
    const loginUserState = useAppSelector((state) => state.loginReducer);
    const [countryResultOpen, setCountryResultOpen] = useState(false);
    const [loginResultOpen, setLoginResultOpen] = useState(false);
    const [chooseWorldItem, setChooseWorldItem] = useState<WorldModel>();
    const dispatch = useDispatch<AppDispatch>();
    const messageState = useAppSelector((state) => state.messageReducer);
    const [openSnackbar, setOpenSnackbar] = React.useState(false);
    const [snackbarMessage, setSnackbarMessage] = React.useState('');
    const [snackbarSort, setSnackbarSort] = React.useState<any>('success');
    const [isDark, setDark] = useLocalStorage<boolean>(THEME_STATE_KEY, false);

    useEffect(() => {
        if (messageState.message) {
            setSnackbarSort(messageState.sort);
            setSnackbarMessage(messageState.message);
            setOpenSnackbar(true);
        }
    }, [messageState]);
    const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackbar(false);
    };

    const [theme, setTheme] = useState<'light' | 'dark'>();

    function countryItemClick(item: WorldModel) {
        setCountryResultOpen(false);
        setChooseWorldItem(item);
    }

    function getWorldCountryComponent() {
        return <WorldCountryList itemClick={(item) => countryItemClick(item)}/>;
    }

    const setDarkTheme = () => {
        setDark(true)
        setTheme('dark');
        document.cookie = `theme=dark; path=/; max-age=31536000`;
        router.refresh()
    };

    const setLightTheme = () => {
        setDark(false)
        setTheme('light');
        document.cookie = `theme=light; path=/; max-age=31536000`;
        router.refresh()
    };

    useEffect(() => {
        // if (searchParams?.get(SH_TITLE)) {
        //     setHasToolbar(true);
        // } else {
        //     setHasToolbar(false);
        // }
        if (typeof document !== 'undefined') {
            setTheme(document.cookie.includes('dark') ? 'dark' : 'light');
        }
        const mainTab=checkMainTabs()
        setMainTab(mainTab)
        setHasMargin(mainTab)
        setSearchPath(pathname.includes("search"))
        if (rdd.isMobile) {
            if (pathname == "/" && !isPWAInstall()) {
                if (rdd.isIOS) {
                    setIosPopUp(true);
                }
                setInstallPopUpOpen(true);
            }
        }
    }, [pathname])

    useEffect(() => {
        if (loginUserState?.state == LOGOUT_STATE) {
            setLoginResultOpen(true);
        } else if (loginUserState?.openLoginPage) {
            setChooseWorldItem(undefined)
            setLoginResultOpen(true);
        } else {
            setLoginResultOpen(false);
        }
    }, [loginUserState]);

    function isPWAInstall(): boolean {
        if (typeof window !== 'undefined') {
            return window.matchMedia('(display-mode: standalone)').matches;
        } else {
            return false;
        }
    }

    function checkMainTabs(): boolean {
        if(pathname) {
            return (pathname == "/" || pathname?.replace("/", "").trim() == (HOME_KEY) || pathname?.replace("/", "").trim() == (SEARCH_KEY) || pathname?.replace("/", "").trim() == (STORE_KEY) || pathname?.replace("/", "").trim() == (TOOLS_KEY) || pathname.replace("/", "").trim() == (VIDEO_KEY) || pathname.replace("/", "").trim() == (GAME_KEY));
        }else{
            return false;
        }
    }

    const handleChangeTab = (event: React.SyntheticEvent | null, newValue: string) => {
        setTabValue(newValue);
        saveLastTab(newValue)
        router.replace(`/${newValue}`);
    };

    function onSearchClick() {
        return () => {
            router.push(SEARCH_SHORTCUT)
        };
    }

    function getDrawerComponent() {
        if (isLogin) {
            return <LogoutUser cancelClick={() => onCloseBottomSheet(false)} okClick={() => logoutUser()}/>;
        } else {
            return <LoginEnterNumber worldItem={chooseWorldItem} countryClick={() => countryOpenClick()}
                                     loginSuccess={()=> {
                                         setLogin(true)
                                         if (typeof window !== 'undefined') window.location.reload()
                                     }}/>;
        }
    }

    function onCloseBottomSheet(open: boolean) {
        dispatch(loginState({state: LOGIN_STATE, openLoginPage: false}));
        setLoginResultOpen(open);
    }

    async function countryOpenClick() {
        setCountryResultOpen(true);
    }

    function logoutUser() {
        onCloseBottomSheet(false)
        saveLoginParams('', '', '', '');
        setLogin(false);
        if (typeof window !== 'undefined') window.location.reload()
    }

    function profileClick() {
        dispatch(loginState({state: LOGIN_STATE, openLoginPage: true}))
    }

    return (
        <Column className={"w-full"}>
            <Column className={`w-full ${searchPath ? "hidden" : ""}`}>
                <div className={hasMargin ? "h-16" : "h-0"}/>
                <Container maxWidth={"lg"}
                           className={`w-full items-center !h-14 ${!mainTab ? "hidden md:fixed md:flex" : "fixed flex"} bgMain px-4 z-50`}>
                    <div className="mt-1 mx-1 block sm:hidden rounded-full cursor-pointer"
                         onClick={() => setDrawerOpen(true)}>
                        <MenuIcon className={"mText"} fontSize={'medium'}/>
                    </div>
                    <div className="mt-1 px-4 rounded-full cursor-pointer hidden sm:flex flex-row center"
                         onClick={() => handleChangeTab(null, HOME_KEY)}>
                        <Image fill={true} sizes={'100%'} alt={''} src={LOGO_ICON}
                               className={'!w-8 !h-8 !relative'}/>
                        <Image
                            fill={true}
                            sizes={'100%'}
                            alt=""
                            className="logoImageText !relative"
                            src={LOGO_TEXT_ADDRESS}
                        />
                    </div>
                    <Tabs
                        value={tabValue}
                        onChange={handleChangeTab}
                        textColor="secondary"
                        scrollButtons={true}
                        indicatorColor="secondary"
                        className={`px-5 !hidden sm:!block sm:max-w-1/3 md:max-w-3/5 h-12 z-50 bgMain grow`}
                        aria-label="secondary tabs example">
                        <Tab value={HOME_KEY} label={t('home')} className={"font"}
                             sx={{color: "var(--theme-page-text)"}}/>
                        <Tab value={TOOLS_KEY} label={t('tools')} className={"font"}
                             sx={{color: "var(--theme-page-text)"}}/>
                        <Tab value={STORE_KEY} label={t('financialText')} className={"font"}
                             sx={{color: "var(--theme-page-text)"}}/>
                        <Tab value={VIDEO_KEY} label={t('videoPlus')} className={"font"}
                             sx={{color: "var(--theme-page-text)"}}/>
                        <Tab value={GAME_KEY} label={t('game')} className={"font "}
                             sx={{color: "var(--theme-page-text)"}}/>
                    </Tabs>
                    <div className={`mt-1 mx-3 center flex-row hidden sm:flex`}>
                        <IconButton className={'!w-10 !h-10'}>
                            {theme == 'light' ?
                                <LightModeOutlinedIcon onClick={setDarkTheme} fontSize={'medium'}
                                                       className={'mx-2 pointer mText opacity-90'}/> :
                                <DarkModeOutlinedIcon onClick={setLightTheme} fontSize={'medium'} className={'mx-2 pointer mText opacity-90'}/>}
                        </IconButton>
                        <IconButton className={'!w-10 !h-10'} onClick={() => profileClick()}>
                            <AccountCircleOutlinedIcon
                                fontSize={'medium'}
                                className={'mx-2 cursor-pointer mText opacity-90'}
                            />
                        </IconButton>
                    </div>
                    <div
                        className="flex flex-row w-full grow sm:w-1/3 md:w-1/5 p-1 mt-1 mx-1 toolbarSearchFrame items-center pointer"
                        onClick={onSearchClick()}
                    >
                        <Image
                            alt=""
                            fill={true}
                            sizes={'100%'}
                            className="searchIcon p-1 ms-2 !relative"
                            src={SEARCH_ICON_ADDRESS}
                        />
                        <div className="toolbarItems text-base p-1">{t('searchIn')}</div>
                    </div>

                </Container>
            </Column>
            <SwipeableDrawer
                anchor={'right'}
                open={drawerOpen}
                variant={'temporary'}
                disableSwipeToOpen={true}
                PaperProps={{
                    square: false,
                    elevation: 0,
                    style: {
                        backgroundColor: 'transparent',
                        left: 'unset',
                        right: 0,
                        width: '16rem'
                    }
                }}
                onOpen={() => setDrawerOpen(true)}
                onClose={() => setDrawerOpen(!drawerOpen)}
            >
                <LayoutDrawer>
                    <Profile closeDrawer={() => setDrawerOpen(false)}/>
                </LayoutDrawer>
            </SwipeableDrawer>
            <SwipeableDrawer
                anchor={'bottom'}
                open={installPopUpOpen}
                disableSwipeToOpen={true}
                PaperProps={{square: true, elevation: 0, style: {backgroundColor: '#fff'}}}
                onOpen={() => setInstallPopUpOpen(true)}
                onClose={() => setInstallPopUpOpen(!installPopUpOpen)}
            >
                <Container maxWidth={'md'} disableGutters={true}
                           className={`w-screen min-h-screen background App light ${vazirmatn.className}`}>
                    {isIosPopUp ? (
                        <Column className={'items-center relative min-h-screen'}>
                            <div className="mt-20 px-4 rounded-full pointer flex flex-row totalCenter">
                                <Image fill={true} sizes={'100%'} alt={''} src={LOGO_ICON}
                                       className={'!w-16 !h-16 !relative'}/>
                                <Image
                                    fill={true}
                                    sizes={'100%'}
                                    alt=""
                                    className="logoImageText !relative"
                                    src={LOGO_TEXT_ADDRESS}
                                />
                            </div>
                            <div
                                className={'px-8  text-lg text-center font-bold mt-8'}>{t('profile.addToolboxToMainPageIos')}</div>
                            <div
                                className={'px-4 text-base text-center mt-8'}>{t('profile.addToolboxToMainPageIosDesc')}</div>
                            <Row className={'totalCenter px-8  mt-8'}>
                                <div
                                    className={'text-sm w-full'}>{toPersianNumber(t('profile.addToolboxToMainPageIosGuide1'))}</div>
                                <IosShareIcon fontSize={'medium'} className={'mx-2 !w-8'}/>
                            </Row>
                            <Row className={'totalCenter px-8  mt-4'}>
                                <div
                                    className={'text-sm w-full'}>{toPersianNumber(t('profile.addToolboxToMainPageIosGuide2'))}</div>
                                <AddBoxOutlinedIcon fontSize={'medium'} className={'mx-2 !w-8'}/>
                            </Row>
                            <Row className={'totalCenter px-8  mt-4'}>
                                <div
                                    className={'text-sm w-full'}>{toPersianNumber(t('profile.addToolboxToMainPageIosGuide3'))}</div>
                                <div className={'!w-12'}>Add</div>
                            </Row>
                            <BlueButton
                                width={'w-2/3'}
                                className={'fixed bottom-20'}
                                text={t('profile.notNow')}
                                onClick={() => setInstallPopUpOpen(false)}
                            />
                        </Column>
                    ) : (
                        <Column className={'items-center relative h-full'}>
                            <div className="mt-20 px-4 rounded-full pointer flex flex-row totalCenter">
                                <Image fill={true} sizes={'100%'} alt={''} src={LOGO_ICON}
                                       className={'!w-16 !h-16 !relative'}/>
                                <Image
                                    fill={true}
                                    sizes={'100%'}
                                    alt=""
                                    className="logoImageText !relative"
                                    src={LOGO_TEXT_ADDRESS}
                                />
                            </div>
                            <div className={'px-8 text-lg text-center font-bold mt-4'}>
                                <span>{t('profile.addToolboxToYourApplication')}</span><span role="img"
                                                                                             aria-label="dog">🌹</span>
                            </div>
                            {(`${process.env.NEXT_PUBLIC_NODE_ENV}`.trim() == ENGLISH_APP) ? null :
                                <a
                                    target="_blank"
                                    rel="noreferrer"
                                    className={"w-full flex flex-row totalCenter"}
                                    href={CAFE_TOOLBOX_URL}>
                                    <Image
                                        fill={true}
                                        sizes={'100%'}
                                        alt={''}
                                        className={'mx-2 rounded-md pointer !h-12 mt-8 px-8 !relative'}
                                        src={CAFE_DOWNLOAD_IMAGE}
                                    />
                                </a>}
                            {(`${process.env.NEXT_PUBLIC_NODE_ENV}`.trim() == ENGLISH_APP) ?
                                <a
                                    target="_blank"
                                    rel="noreferrer"
                                    className={"w-full flex flex-row totalCenter"}
                                    href={PLAY_TOOLBOX_URL}>
                                    <Image
                                        fill={true}
                                        sizes={'100%'}
                                        alt={''}
                                        className={'mx-2 rounded-md pointer !h-12 mt-4 px-8 !relative'}
                                        src={PLAY_DOWNLOAD_IMAGE}
                                    />
                                </a> : null}
                            {(`${process.env.NEXT_PUBLIC_NODE_ENV}`.trim() == ENGLISH_APP) ? null :
                                <a
                                    target="_blank"
                                    rel="noreferrer"
                                    className={"w-full flex flex-row totalCenter"}
                                    href={MYKET_TOOLBOX_URL}>
                                    <Image
                                        fill={true}
                                        sizes={'100%'}
                                        alt={''}
                                        className={'mx-2 rounded-md pointer !h-12 mt-4 px-8 !relative'}
                                        src={MYKET_DOWNLOAD_IMAGE}
                                    />
                                </a>}
                            <a
                                target="_blank"
                                rel="noreferrer"
                                className={"w-full flex flex-row totalCenter"}
                                href={DIRECT_CAFE_TOOLBOX_URL}>
                                <Image
                                    fill={true}
                                    sizes={'100%'}
                                    alt={''}
                                    className={'mx-2 rounded-md pointer !h-12 mt-4 px-8 !relative'}
                                    src={(`${process.env.NEXT_PUBLIC_NODE_ENV}`.trim() == ENGLISH_APP) ? DIRECT_DOWNLOAD_EN_IMAGE : DIRECT_DOWNLOAD_IMAGE}
                                />
                            </a>
                            <BlueButton
                                width={'w-2/3'}
                                className={'fixed bottom-20'}
                                text={t('profile.notNow')}
                                onClick={() => setInstallPopUpOpen(false)}
                            />
                        </Column>
                    )}
                </Container>
            </SwipeableDrawer>
            <SwipeableDrawer
                anchor={'bottom'}
                open={loginResultOpen}
                disableSwipeToOpen={true}
                PaperProps={{square: false, elevation: 0, style: {backgroundColor: 'transparent'}}}
                onOpen={() => setLoginResultOpen(true)}
                onClose={() => onCloseBottomSheet(!loginResultOpen)}
            >
                <LayoutDrawer>
                    <RTLContainer>
                        {loginResultOpen?
                            <GoogleReCaptchaProvider
                                reCaptchaKey={`${process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY}`}
                                scriptProps={{async: true, defer: true}}
                                container={{
                                    parameters: {
                                        badge: "inline"
                                    }
                                }}>
                                {getDrawerComponent()}
                            </GoogleReCaptchaProvider>
                            :null}
                    </RTLContainer>
                </LayoutDrawer>
            </SwipeableDrawer>

            {countryResultOpen ? <SwipeableDrawer
                anchor={'bottom'}
                open={countryResultOpen}
                disableSwipeToOpen={true}
                PaperProps={{square: false, elevation: 0, style: {backgroundColor: 'transparent'}}}
                onOpen={() => setCountryResultOpen(true)}
                onClose={() => setCountryResultOpen(!countryResultOpen)}
            >
                <LayoutDrawer>
                    {getWorldCountryComponent()}
                </LayoutDrawer>
            </SwipeableDrawer> : null}
            <Snackbar open={openSnackbar} autoHideDuration={3000} onClose={handleClose}>
                <Alert className={"font"} onClose={handleClose} severity={snackbarSort} sx={{width: '100%'}}>
                    {snackbarMessage}
                </Alert>
            </Snackbar>
        </Column>
    )

}